<ng-template #documentContent let-modal>
    <div class="modal-header bg-theme bg-theme-txt">
      <h5 class="modal-title" id="modal-basic-title">Terms of Usage of PGB LLP IT-Assets: </h5>
    </div>
    <div class="modal-body">
      <div class="container">
        1. <span class="fontStyle">You shall remain responsible</span> for the use of the software, hardware allotted to you or under your control or any other asset allocated and / or used by you.
        <hr/>
        2.	You shall adhere to following best practices to <span class="fontStyle">avoid placing any unnecessary risk</span> to the allocated hardware / software.
        <hr/>
        3.	All the IT facilities or personal IT devices, systems, software’s etc. used for official PGB work activities should be for <span class="fontStyle">legal purposes only</span>.
        <hr/>
        4.	You shall be responsible for safe and proper usage of the allocated hardware. In case there is any damage to the same due to wrong handling, accidents etc.<span class="fontStyle">PGB shall have right to recover appropriate replacement costs</span> as will be deemed necessary by the Partners.
        <hr/>
        5.	You shall <span class="fontStyle">not download any unwanted software</span> or programs on the laptop, <span class="fontStyle">neither will you misuse the software licenses</span> on any other machine.
        <hr/>
        6.	You must ensure that the operating systems and the various official / authorized software are <span class="fontStyle">kept up-to-date</span> especially in relation to the security & anti-virus updates.
        <hr/>
        7.	While using various remote access or onsite facilities and other IT systems of the clients, you shall ensure <span class="fontStyle">adherence to the client’s IT policy</span>. 
        <hr/>
        8.	If there are any <span class="fontStyle">conflicts to the PGB IT policy</span> the same should be brought to the notice of the HR / Admin Manager and Partners.
        <hr/>
        9.	Any hardware / software asset related issues, for <span class="fontStyle">troubleshooting,</span> should be promptly conveyed to HR / Admin manager, through official e-mail with adequate proofs (pictures, screenshots, videos), with CC to respective Manager / Partner. Refer SOP uploaded on E-diary for the same.
        <hr/>
        10.	All the Partners, Principals, Senior Managers, Managers and any other designated persons shall have <span class="fontStyle">right to inspect</span> for any violation.
        <hr/>
        11.	Access to copy data etc. to <span class="fontStyle">external storage devices is prohibited.</span> You will be able to copy data from the external device to the laptop, however the reverse is blocked for security purposes.
        <hr/>
        12.	Each laptop will have access through a user ID. The <span class="fontStyle">Admin ID</span> will be created and accessible to only the HR / Admin Manager or Partner in charge.
        <hr/>
        13.	Every laptop comes equipped with an <span class="fontStyle">antivirus,</span> which should be periodically used for scanning and PC tunning. Each user should ensure that anti-virus is up-to-date and is not expired or out of date.
        <hr/>
        14.	You are expected to use the <span class="fontStyle">Internet responsibly and productively.</span> Internet access is limited to work-related activities only and <span class="fontStyle">personal use is not permitted.</span> Sending or posting information that is defamatory to the Firm, its products/services, colleagues and/or clients is unacceptable. All sites and downloads may be monitored and/or blocked by PGB if they are deemed to be harmful and/or not productive to business. 
        <hr/>
        15.	<span class="fontStyle">No personal data</span> to be stored on the laptops. Any such instance found would make me liable for disciplinary actions as deemed necessary by Partners. 
        <hr/>
        16.	Administrators will have <span class="fontStyle">right to delete the excess or unauthorized data,</span> as required to ensure adherence to the data host requirements / policies. 
        <hr/> 
        <input type="checkbox" name="acceptUses" id="acceptUses" [(ngModel)]="acceptUses"> 
        I, the undersigned, herewith accept the terms and conditions of the usage of <span style="font-weight: bold;">P G BHAGWAT LLP’s</span> assets (whether hardware or software) allocated to me and agree fully to comply therewith to the satisfaction of the Firm’s IT policies.
       <hr/>

     <div class="row">
      <label>Name :</label>&nbsp;&nbsp;
      <span>{{name}}</span>
      </div>
      <div class="row">
        <label>Designation :</label> &nbsp;&nbsp;
        <span>{{designation}}</span>
      </div>
      <div class="row">
        <label>Signature :</label>&nbsp;&nbsp;
        <span>
            <input type="checkbox" id="signAfterAccept" name="signAfterAccept" [(ngModel)]="signAfterAccept"></span>
      </div>
      <div class="row">
        <label>Date :</label>&nbsp;&nbsp;
        <span> {{currentDate.day}}/{{currentDate.month}}/{{currentDate.year}} </span>
      </div>
    </div>

</div>

    <div class="modal-footer" style="">
      <div class="row col-md-12">
        <div class="col-sm-9"></div>
        <div class="col-sm-3">
            <button
              id="okStandardBtn"
              name="okStandardBtn"
              type="button"
              class="btn btn-sm btn-block btn-outline-secondary"
              (click)="okButtonClick()">
              Ok
            </button>
          </div>
        <!-- <div class="col-sm-3">
          <button
            id="closeStandardBtn"
            name="closeStandardBtn"
            type="button"
            class="btn btn-sm btn-block btn-outline-secondary"
            (click)="modal.dismiss('Cross click')"
          >
            Close
          </button>
        </div> -->
      </div>
    </div>
  </ng-template>